import { Icon, WrapperIcon } from './PageBox.styles';

type PageBoxIconProps = {
	icon: string;
	alt: string;
};

export const PageBoxIcon = ({ icon, alt }: PageBoxIconProps): JSX.Element => (
	<WrapperIcon>
		<Icon src={icon} alt={alt} />
	</WrapperIcon>
);
